"use client";

import { create } from "zustand";

type UiState = {
  mobileOpen: boolean;
  sidebarCollapsed: boolean;
  loading: boolean;
  setMobileOpen: (open: boolean) => void;
  toggleMobileOpen: () => void;
  setSidebarCollapsed: (v: boolean) => void;
  toggleSidebarCollapsed: () => void;
  setLoading: (v: boolean) => void;
  addNotification: (payload: {
    type?: string;
    title?: string;
    message?: string;
  }) => void;
};

export const useUIStore = create<UiState>((set) => ({
  mobileOpen: false,
  sidebarCollapsed: false,
  loading: false,
  setMobileOpen: (open: boolean) => set({ mobileOpen: open }),
  toggleMobileOpen: () => set((s) => ({ mobileOpen: !s.mobileOpen })),
  setSidebarCollapsed: (v: boolean) => set({ sidebarCollapsed: v }),
  toggleSidebarCollapsed: () =>
    set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),
  setLoading: (v: boolean) => set({ loading: v }),
  addNotification: () => {
    // placeholder - application uses toasts for notifications (sonner),
    // keep API for convenience and testing.
  },
}));
